import { Dialog, DialogContent } from '@mui/material';
import { ReactNode } from 'react';
import { GenericDialogProps } from 'utilities/dialog-context/dialog-context-helpers';
import CloseableDialogTitle from './components/dialog-components/closeable-dialog-title';

export interface RichMessageDialogUniqueProps {
  title: string;
  content: ReactNode;
}
export type RichMessageCallbackInput = null;
export type RichMessageDialogProps = GenericDialogProps<null> &
  RichMessageDialogUniqueProps;

export const RichMessageDialog = ({
  title,
  content,
  open,
  setOpen,
}: RichMessageDialogProps) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm">
      <CloseableDialogTitle title={title} handleClose={handleClose} />
      <DialogContent sx={{ padding: '12px 24px 24px' }}>
        {content}
      </DialogContent>
    </Dialog>
  );
};

export default RichMessageDialog;
